// Copyright (c) Zammo Inc.
import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module';
import './index.css';

import App from './App';
import AssistantChat from './components/AssistantChat';
import * as serviceWorker from './serviceWorker';

const initializeOPtions = {
  testMode: process.env.NODE_ENV === 'development',
  gaOptions: {
    allowLinker: true,
  },
};

const gaMeasurementId = 'UA-157129108-1';

ReactGA.initialize(gaMeasurementId, initializeOPtions);

// eslint-disable-next-line no-underscore-dangle
ReactGA._gtag('set', {
  custom_map: { dimension1: 'User ID', dimension2: 'Organization Name' },
});

// eslint-disable-next-line no-underscore-dangle
ReactGA._gtag('config', gaMeasurementId, {
  linker: {
    domains: ['app.zammo.ai', 'try.zammo.ai', 'builder.zammo.ai', 'pricing.zammo.ai'], // TODO setup for demo environment
  },
  send_page_view: false,
});

if (process.env.NODE_ENVIRONMENT !== 'development') {
  const tagManagerArgs = {
    gtmId: 'GTM-KQ8F4ZH',
  };

  TagManager.initialize(tagManagerArgs);
}

Modal.setAppElement('#root');

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Switch>
        {/* Standalone ChatGPT-style surface — interim host for the "assistant" channel. */}
        <Route path="/chat" component={AssistantChat} />
        <Route path="/" component={App} />
      </Switch>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
